import { Base64 } from 'js-base64';
import $ from 'jquery';
import { getStaticEPFAccessToken } from '../general/EpfTokensUtils';
import { isEmpty } from 'lodash';

class RenditionUrlGenerator {
    public static URL_GENERATOR: any = {
        baseUrl() {
            if (window.HTML_RENDITION.initialData.isPublic){
                return window.HTML_RENDITION.initialData.publicWebBase + '/';
            }
            return '/rendition/eppublic/documentService/';
        },
        environments(params: any) {
            const environmentsType: any = {
                LOCAL: 'http://localhost:9090',
                QA: 'https://qa.citivelocity.com',
                DEV: 'https://qa.citivelocity.com',
                UAT: 'https://uat.citivelocity.com',
                PROD: 'https://www.citivelocity.com'
            };
            return environmentsType[params?.toUpperCase()];
        },
        getStaticPart(params: any) {
            const paramString: any = [];
            for (const param in params) {
                // skip loop if the property is from prototype
                if (!params.hasOwnProperty(param)) continue;
                paramString.push(param + "=" + params[param]);
            }
            if (window.btoa) {
                return window.btoa(paramString.join('&'));
            }
            if (Base64) {
                return Base64.encode(paramString.join('&'));
            }
            return null;
        },
        validate(params: any, env: string) {
            try {
                for (const param in params) {
                    // skip loop if the property is from prototype
                    if (!params.hasOwnProperty(param)) continue;
                    if (!params[param]) throw new Error(param + " parameter is mandatory. It cannot be empty.");
                }
                if (!env) throw new Error("'env' parameter is mandatory & it should be either one of these QA, UAT or PROD.");
                if (!window.btoa && !Base64) throw new Error("atob/btoa or B64 functions were not supported by browser");
                return true;
            } catch (err) {
                console && console.log(err);
                return false;
            }
        },
        getURL(params: any, env: string) {
            return this.environments(env.toUpperCase()) + this.baseUrl() + this.getStaticPart(params);
        },
        generateByDocId(doc_id: string | number, env: string) {
            const params = {
                doc_id
            };
            if (this.validate(params, env)) {
                return this.getURL(params, env);
            }
        },
        generateByVideoId(video_id: any, env: string) {
            const params = {
                video_id
            };
            if (this.validate(params, env)) {
                return this.getURL(params, env);
            }
        },
        generateByMultimediaURL(multimedia_url: string, doc_id: string | number, env: any) {
            if (arguments.length < 3) {
                console && console.log("Need all 3 parameters. {multimedia_url, doc_id, env}");
                return;
            }
            const params = {
                multimedia_url,
                doc_id,
                platform: '109' // HTML_RENDITION.platform
            };
            if (this.validate(params, env)) {
                return this.getURL(params, env);
            }
        },
        generateByCGIMultimediaURL(multimedia_url: string, doc_id: string | number, env: any) {
            if (arguments.length < 3) {
                console && console.log("Need all 3 parameters. {multimedia_url, doc_id, env}");
                return;
            }
            const params = {
                multimedia_url,
                doc_id,
                platform: '109' // HTML_RENDITION.platform
            };
            if (this.validate(params, env)) {
                const paramString: any = "multimedia_url=" + window.encodeURIComponent(multimedia_url) + "&doc_id=" + doc_id + "&platform=109";
                return this.environments(env.toUpperCase()) + window.HTML_RENDITION.initialData.publicWebBase + "?" + paramString;
            }
        },
        generateAuthFileLinkPublicURL(inputUrl: string) {
             const epfToken = getStaticEPFAccessToken();
             if (!isEmpty(epfToken)) {
                return $.ajax({
                    type : 'GET',
                    url: `/rendition/urlfactoryws/eppublic/V1/URL.json?__epftoken=${epfToken}`,
                    data: {
                        urlType: 'AUTH_FILE_LINK_PUBLIC',
                        platformId: 78,
                        documentIdentifierText: inputUrl
                      },
                    headers: {
                        Accept: "application/json",
                        callerId: 'RENDITIONBE',
                        Authorization: `Bearer ${epfToken}`
                    },
                    async:false,
                  });
            }

            return $.ajax({
                type : 'GET',
                url:"/rendition/urlfactoryws/eppublic/V1/URL.json",
                data: {
                    urlType: 'AUTH_FILE_LINK_PUBLIC',
                    platformId: 78,
                    documentIdentifierText: inputUrl
                  },
                headers: {
                    Accept: "application/json",
                    callerId: 'RENDITIONBE'
                },
                async:false,
              });
        }
    };
}

export default RenditionUrlGenerator;
